"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupOptionsStruct = exports.IdentifyOptionsStruct = exports.callback = void 0;
const superstruct_1 = require("superstruct");
const callback = () => (0, superstruct_1.define)("callback", (0, superstruct_1.func)().validator);
exports.callback = callback;
exports.IdentifyOptionsStruct = (0, superstruct_1.partial)({ intent: (0, superstruct_1.string)() });
/**
 * Parameter for .group() API.
 * At least one of the field must be present.
 */
exports.GroupOptionsStruct = (0, superstruct_1.refine)((0, superstruct_1.partial)({
    hubId: (0, superstruct_1.string)(),
    hubUrn: (0, superstruct_1.string)(),
    projectId: (0, superstruct_1.string)(),
    projectUrn: (0, superstruct_1.string)(),
}), "GroupOptions", (value) => {
    const { hubId, projectId } = value;
    return (0, superstruct_1.is)(hubId || projectId, (0, superstruct_1.nonempty)((0, superstruct_1.string)()));
});
